<dx-popup
  #popupRef
  [visible]=""
  [deferRendering]="false"
  [showCloseButton]="showCloseButton"
  [resizeEnabled]="true"
  [width]="width"
  [height]="height"
  maxHeight="100vh"
  maxWidth="100vw"
  [fullScreen]="isFullScreen"
  [wrapperAttr]="{
    class:
      'modal-window__popup ' + (useScrollView ? 'modal-window__popup--scroll-view ' : '') + customClass,
  }"
  (onInitialized)="onInitialized($event)"
  (onShowing)="onShowing.emit($event)"
  (onShown)="onShown.emit($event)"
  (onHidden)="onHidden.emit($event)"
  (onResize)="handleResize($event)"
  [animation]=""
  [container]="container"
  [shading]="shading"
>
  <dxi-popup-toolbar-item
    *ngFor="let toolbarItem of extraToolbarItems"
    [widget]="$any(toolbarItem.widget)"
    [visible]="toolbarItem.visible"
    [location]="$any(toolbarItem.location)"
    [toolbar]="$any(toolbarItem.toolbar)"
    [cssClass]="toolbarItem.cssClass"
    [options]="toolbarItem.options"
  >
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item [visible]="!!title" location="before">
    <div *dxTemplate>
      <span class="modal-window__title">{{ title }}</span>
    </div>
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item [visible]="!!htmlTitle" location="before">
    <div *dxTemplate>
      <span class="modal-window__title" [innerHTML]="htmlTitle"></span>
    </div>
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    cssClass="modal-window__fullscreen-button"
    [visible]="showFullScreenButton"
    [options]="{
      stylingMode: 'text',
      icon: 'fullscreen',
      onClick: toggleScreenSize,
    }"
  >
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [visible]="showCancelButton"
    cssClass="modal-window__toolbar-item modal-window__toolbar-item--desktop"
    [options]="{
      text: cancelTitle,
      onClick: hideModal,
      elementAttr: {
        class: 'modal-window__toolbar-button',
      },
    }"
  >
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    [visible]="showSaveButton"
    widget="dxButton"
    location="after"
    cssClass="modal-window__toolbar-item modal-window__toolbar-item--desktop"
    toolbar="bottom"
  >
    <div *dxTemplate>
      <shr-button-with-indicator
        [title]="actionTitle"
        [disabled]="saveButtonDisabled || isLoading"
        [cssClass]="'modal-window__toolbar-button'"
        [isInProgress]="inProgress"
        (onClick)="handelSaveClick()"
      ></shr-button-with-indicator>
    </div>
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    [visible]="showSaveButton"
    location="after"
    cssClass="modal-window__toolbar-item modal-window__toolbar-item--mobile"
    toolbar="bottom"
  >
    <div *dxTemplate>
      <div class="modal-window__toolbar-actions-container">
        <dx-button
          *ngIf="showCancelButton"
          class="modal-window__toolbar-button modal-window__toolbar-button--mobile"
          icon="undo"
          [stylingMode]="'text'"
          [type]="'danger'"
          (onClick)="hideModal()"
        ></dx-button>

        <shr-button-with-indicator
          [title]="null"
          [icon]="actionIcon"
          [disabled]="saveButtonDisabled || isLoading"
          [cssClass]="
            'modal-window__toolbar-button modal-window__toolbar-button--mobile modal-window__toolbar-button--save'
          "
          [isInProgress]="inProgress"
          (onClick)="handelSaveClick()"
        ></shr-button-with-indicator>
      </div>
    </div>
  </dxi-popup-toolbar-item>

  <div class="modal-window-main-layout">
    <div class="modal-window-main-layout__content modal-window-main-layout__content--modal">
      <dx-scroll-view
        *ngIf="useScrollView; else content"
        height="100%"
        direction="vertical"
        [useNative]="false"
        [showScrollbar]="'always'"
      >
        <ng-container *ngTemplateOutlet="content"> </ng-container>
      </dx-scroll-view>
    </div>
  </div>
</dx-popup>

<!--
  Deliberately OUTSIDE the popup, and full screen.

  A modal whose height depends on what it loads would otherwise open empty and
  then jump to its real size once the data arrived, which reads worse than a short
  wait. Living outside the popup lets this cover the screen BEFORE the modal opens,
  so the caller can fetch first and show the modal already at its final size — and
  the click still gets an immediate response instead of a dead button.
-->
<dx-load-panel
  *ngIf="isLoading"
  shadingColor="rgba(0,0,0,0.4)"
  [visible]="true"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<ng-template #content> <ng-content></ng-content> </ng-template>
